module.exports = __webpack_public_path__ + "static/media/retirement-object-1-0-2.e8af3c1a.svg";